import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Check, Circle, Loader2 } from "lucide-react";

export default function RentalTimeline({ bookingId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!bookingId) return;
    api.get(`/bookings/${bookingId}/timeline`)
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [bookingId]);
  if (loading) return <div className="text-white/50 text-xs inline-flex items-center gap-2"><Loader2 size={12} className="animate-spin" /> Loading timeline…</div>;
  if (!data) return null;
  return (
    <div data-testid="rental-timeline" className="rounded-2xl border border-white/10 bg-black/30 p-4">
      <div className="label-caps text-cyan text-[10px] mb-3">Rental progress · {data.reservation_id || bookingId}</div>
      <ol className="space-y-2">
        {data.steps.map((s, i) => (
          <li key={s.key} className="flex items-start gap-3">
            <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
              s.done ? "bg-lime-400 text-black" : "bg-white/10 text-white/40"
            }`}>
              {s.done ? <Check size={12} /> : <Circle size={10} />}
            </div>
            <div className="flex-1">
              <div className={`text-sm ${s.done ? "text-white" : "text-white/50"}`}>{s.label}</div>
              {s.at && <div className="text-[10px] text-white/40">{new Date(s.at).toLocaleString()}</div>}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
